import {useHistory, useParams} from "react-router-dom";
import {DELETE, PGET, PUT} from "../../../api/adminApi";
import React, {useEffect, useState} from "react";
import {get} from "lodash";
import {Button, Descriptions, Tag, Image} from "antd";
import Table from "../../ui/Table";
import AddProduct from "./AddProduct";
import {BiTrash} from "react-icons/bi";
import {FaMoneyBill} from "react-icons/fa6";
import {moneyFormatter} from "../../../utils/utilities";
import {FaHistory} from "react-icons/fa";

const AgreementDetail = () => {
    const {id} = useParams()
    const [open, setOpen] = useState(false)
    const [details, setDetails] = useState()
    const [productDetails, setProductDetails] = useState()
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(3);
    const history = useHistory()

    async function getDetails() {
        const response = await PGET(`/services/admin/api/agreement/${id}`)
        if (response) {
            setDetails(response)
        }
    }

    async function getProductDetails() {
        const response = await PGET(`/services/admin/api/agreement-products`, true, {
            agreementId: id
        })
        if (response) {
            setProductDetails(response)
        }
    }

    async function deleteItem(id) {
        await DELETE("/services/admin/api/agreement-products/" + id);
        getProductDetails()
    }

    async function activate(id) {
        await PUT("/services/admin/api/agreement-activate/" + id);
        getDetails()
        getProductDetails()
    }

    useEffect(() => {
        getDetails()
        getProductDetails()
    }, []);
    let statusId = get(details, 'data.statusId')

    const columns = [
        {
            title: "Название",
            key: "name",
            dataIndex: "productName",
            render: (item) => (
                <div className="text-left">
                    {item}
                </div>
            ),
        },
        {
            title: "Фото",
            key: "photoFilePath",
            dataIndex: "photoFilePath",
            render: (item) => (
                <Image
                    width={50}
                    height={50}
                    src={`https://bo.saleinvest.uz/${item}`}
                    fallback="data:image/png;base64,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"
                />
            ),
        },
        {
            title: "Количество",
            key: "amount",
            dataIndex: "amount",
            render: (item) => (
                <div className="text-left">
                    {moneyFormatter(item)}
                </div>
            ),
        },
        {
            title: "Описание",
            key: "description",
            dataIndex: "description",
            render: (item) => (
                <div className="text-left">
                    {item}
                </div>
            ),
        },
        {
            title: "Цена",
            key: "price",
            dataIndex: "price",
            render: (item) => (
                <div className="text-left">
                    {moneyFormatter(item)}
                </div>
            ),
        },
        {
            title: "Действия",
            key: "id",
            dataIndex: "id",
            render: (id) => {
                return (
                    statusId !== 2 &&
                    <Button danger icon={<BiTrash/>} onClick={() => deleteItem(id)} className="text-left"/>
                )
            }
        },
    ]
    const items = [
        {
            key: 1,
            label: "Название",
            children: <p className="text-right p-0 m-0 font-weight-600 text-black">{get(details, 'data.name', '-')}</p>,
            span: 2
        },
        {
            key: 10,
            label: "Предоплата",
            children: <p
                className="text-right p-0 m-0 font-weight-600 text-black">{moneyFormatter(get(details, 'data.firstPayment', '-'))}</p>,
            span: 2
        },
        {
            key: 11,
            label: "Общая цена",
            children: <p
                className="text-right p-0 m-0 font-weight-600 text-black">{moneyFormatter(get(details, 'data.totalPrice', '-'))}</p>,
            span: 2
        },
        {
            key: 11,
            label: "К оплате",
            children: <p
                className="text-right p-0 m-0 font-weight-600 text-black">{moneyFormatter(get(details, 'data.totalForPayment', '-'))}</p>,
            span: 2
        },
        // {
        //     key: 11,
        //     label: "Оплачено",
        //     children: <p
        //         className="text-right p-0 m-0 font-weight-600 text-black">{get(details, 'data.installmentPayAmount', '-')}</p>,
        //     span: 2
        // },
        {
            key: 11,
            label: "Ежемесячно",
            children: <p
                className="text-right p-0 m-0 font-weight-600 text-black">{moneyFormatter(get(details, 'data.installmentPayAmount', '-'))}</p>,
            span: 2
        },

        {
            key: 4,
            label: "Инвестиция",
            children: <p
                className="text-right p-0 m-0 font-weight-600 text-black">{get(details, 'data.investmentName', '-')}</p>,
            span: 2
        },
        {
            key: 5,
            label: "Клиент",
            children: <p
                className="text-right p-0 m-0 font-weight-600 text-black">{get(details, 'data.clientName', '-')}</p>,
            span: 2
        },
        {
            key: 6,
            label: "Стартовая дата",
            children: <p
                className="text-right p-0 m-0 font-weight-600 text-black">{get(details, 'data.createdLocalDate', '-')}</p>,
            span: 2
        },
        {
            key: 7,
            label: "Срок",
            children: <p
                className="text-right p-0 m-0 font-weight-600 text-black">{get(details, 'data.installmentMonthCount', '-')}</p>,
            span: 2
        },
        {
            key: 8,
            label: "Ставка",
            children: <p
                className="text-right p-0 m-0 font-weight-600 text-black">{get(details, 'data.conditionName', '-')}</p>,
            span: 2
        },
        {
            key: 3,
            label: "Описание",
            children: <p className="text-left font-weight-600 text-black">{get(details, 'data.description', '-')}</p>,
            span: 3,
        },]


    return (
        <div className="p-5">
            <div className="flex justify-between items-center">
                <h3 className="my-5 flex">Детали договора {id}
                    <p className="ml-2">
                        {
                            statusId === 1 ?
                                <Tag color="blue">Новый</Tag> :
                                statusId === 2 ?
                                    <Tag color="green">Активный</Tag> :
                                    statusId === 3 ?
                                        <Tag color="red">Закрытый</Tag> :
                                        statusId === 4 ?
                                            <Tag color="yellow">Отмененный</Tag> : '-'
                        }
                    </p>
                </h3>

                <div className="flex">
                    <Button
                        icon={<FaHistory/>}
                        className="flex items-center justify-center mr-2 bg-green"
                        onClick={() => history.push(`/admin/agreement/history/${id}`)}
                        type="primary"
                    >
                        История
                    </Button>
                    {(get(details, 'data.statusId') === 2) && <Button
                        icon={<FaMoneyBill/>}
                        className="flex items-center justify-center mr-2"
                        onClick={() => history.push(`/admin/agreement/payments/${id}`)}
                        type="primary"
                    >
                        Оплаты
                    </Button>}
                    {

                        (get(details, 'data.canBeActivated', false)) &&
                        (get(details, 'data.statusId') === 1) && <Button
                            className="bg-green"
                            onClick={() => activate(id)}
                            type="primary"
                        >
                            Активировать
                        </Button>
                    }
                </div>
            </div>
            <Descriptions title={``} size="small" items={items} bordered/>
            <div className="flex justify-between items-center">
                <h3 className="my-5">Товары договора</h3>
                {(get(details, 'data.statusId') === 1) &&
                    <AddProduct setOpen={setOpen} open={open} getItems={getDetails} getProduct={getProductDetails}/>}
            </div>
            <Table
                page={page}
                setPage={setPage}
                perPage={perPage}
                setPerPage={setPerPage}
                data={get(productDetails, "data", [])}
                totalElements={get(productDetails, "data", [])}
                // onRow={rowClick}
                // isLoading={isLoading || isFetching}
                columns={columns}
            />
        </div>
    )
}

export default AgreementDetail